// eslint-disable-next-line no-restricted-imports
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import * as styles from "./ShimmerPlaceHolder.css";
export var ShimmerPlaceHolder = function(param) {
    var className = param.className, $height = param.$height, $width = param.$width, $aspectRatio = param.$aspectRatio, $backgroundColor = param.$backgroundColor;
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.shimmerPlaceholder, className),
        style: assignInlineVars((_obj = {}, _define_property(_obj, styles.varHeight, $height ? "".concat($height, "px") : "100%"), _define_property(_obj, styles.varWidth, $width ? "".concat($width, "px") : "100%"), _define_property(_obj, styles.varAspectRatio, $aspectRatio ? "".concat($aspectRatio) : ""), _define_property(_obj, styles.varBackgroundColor, $backgroundColor), _obj))
    });
};
